import React from 'react'
import '../Menu/Menu.css'

import Menu1 from '../../Image/menu-1.webp'
import Menu2 from '../../Image/menu-2.webp'
import Menu3 from '../../Image/menu-3.webp'
import Menu4 from '../../Image/menu-4.webp'
import Menu5 from '../../Image/menu-5.webp'
import Menu6 from '../../Image/menu-6.webp'
import Menu7 from '../../Image/menu-7.webp'
import Menu8 from '../../Image/menu-8.webp'
import Menu9 from '../../Image/menu-9.webp'
import Menu10 from '../../Image/menu-10.webp'
function Menu() {
  const Menu = React.lazy(() => import('./Menu'));

  return (
    <>
       <div className='Menu'>
      <p className='Menu-head-text'>Our Menu <i class="fa-solid fa-utensils"></i> </p>
    <div className='Menu-image'>
        <img src={Menu1} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu2} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu3} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu4} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu5} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu6} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu7} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu8} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu9} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>
        <img src={Menu10} rel="preload" as="image" loading="lazy" alt="Error: 0x80004005"/>

    </div>
    </div>
    </>
  )
}

export default Menu